<template lang="pug">
.col-md-12.empty-result(
    :style='{ minHeight: minHeight + "px" }',
    :class='{ justify: minHeight }'
)
    .text-center
        i.mdi(:class='iconClass')
    .text-center
        | {{ message }}
</template>

<script>
export default {
    name: 'EmptyResult',
    props: {
        message: String,

        iconClass: {
            type: String,
            default: 'mdi-inbox'
        },

        minHeight: {
            type: Number,
            default: 100
        }
    }
};
</script>

<style lang="scss" scoped>
.empty-result {
    color: var(--primary-font-color);

    margin-top: 50px;
    margin-bottom: 50px;

    .mdi {
        font-size: 3rem;
        color: var(--secondary-font-color);
    }
}

.justify {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
